import { Card, CardContent, Typography, Grid, Box, CardMedia } from '@mui/material';
import IbssSvgIcon from "../../Icons/SvgIcon/IbssSvgIcon";
import CaretRightIcon from "../../Icons/CaretRightIcon";
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";


class IbssEventNotificationCard extends IbssComponent<IProps, IState>
{
    public render(): JSX.Element
    {
        const { title, message, imageURI } = this.props;

        return (
            <Card sx={{ display: 'flex', cursor: this.props.showDetails ? 'pointer' : 'inherit' }} onClick={()=>{this.props.showDetails && this.props.navigateToDetails(this.props.nodeId, this.props.id)}}>
                <CardMedia
                    component="img"
                    sx={{ width: 160, minWidth: 160, height: 130, objectFit: 'cover' }}
                    image={imageURI}
                    alt="event img"
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', justifyContent: 'center' }}>
                    <CardContent className="card-botom-spacing-0">
                        <Grid container spacing={2} sx={{ pb: 0 }}>
                            <Grid item md={6}>
                                <Typography variant="h6" component="div" mb={2}>
                                    {title}
                                </Typography>
                                <Typography variant="body2">
                                    {message}
                                </Typography>
                            </Grid>
                            <Grid item md={1} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                                {this.props.showDetails &&
                                <IbssSvgIcon
                                    sx={{fontSize:'0.75rem', cursor: 'pointer', padding: '8px', '&:hover': { opacity: 0.8 } }}>
                                    <CaretRightIcon />
                                </IbssSvgIcon>
                                }
                            </Grid>
                        </Grid>
                    </CardContent>
                </Box>
            </Card >
        );
    }

}

export default IbssEventNotificationCard;

interface IProps 
{
    id: string;
    title: string;
    message: string;
    actionURL: string;
    imageURI: string;
    nodeId: number;
    showDetails: boolean;
    navigateToDetails: (nodeId: number, id: string) => void;
}

interface IState
{

}
